import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import {
  Box, Typography, Grid, Card, CardContent, CardActions,
  Button, Avatar
} from '@mui/material';
import {
  People as CoreHRIcon,
  WorkOutline as RecruitmentIcon,
  ArrowForward as ArrowForwardIcon
} from '@mui/icons-material';

const HRMLandingPage = () => {
  const { chatbotId } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    document.title = 'HRM | KlonIT Web Application';
  }, []);

  const cards = [
    {
      title: 'Core HR',
      description: 'Manage employees, departments, positions, and track the complete employee lifecycle from onboarding to offboarding.',
      icon: <CoreHRIcon sx={{ fontSize: 60, color: '#1976d2' }} />,
      link: `/chatbot/${chatbotId}/hrm`,
      color: '#1976d2'
    },
    {
      title: 'Recruitment',
      description: 'Post job requisitions, track applicants through the hiring pipeline, schedule interviews, and manage offer letters.',
      icon: <RecruitmentIcon sx={{ fontSize: 60, color: '#2e7d32' }} />,
      link: `/chatbot/${chatbotId}/hrm/recruitment`,
      color: '#2e7d32'
    }
  ];

  return (
    <Box sx={{ p: { xs: 1.5, sm: 3 }, mt: { xs: 2, sm: 10 } }}>
      <Box sx={{ mb: 4 }}>
        <Typography variant="h4" fontWeight={700} sx={{ fontSize: { xs: '1.5rem', sm: '2.125rem' } }}>
          HRM
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Human Resource Management
        </Typography>
      </Box>

      <Grid container spacing={3}>
        {cards.map((card, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <Card
              sx={{
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                transition: '0.3s',
                cursor: 'pointer',
                '&:hover': {
                  boxShadow: 6,
                  transform: 'translateY(-4px)'
                }
              }}
              onClick={() => navigate(card.link)}
            >
              <CardContent sx={{ flexGrow: 1, textAlign: 'center', pt: 4 }}>
                <Avatar
                  sx={{
                    width: 80,
                    height: 80,
                    bgcolor: `${card.color}15`,
                    margin: '0 auto 16px'
                  }}
                >
                  {card.icon}
                </Avatar>
                <Typography variant="h5" gutterBottom fontWeight={600}>
                  {card.title}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {card.description}
                </Typography>
              </CardContent>
              <CardActions sx={{ justifyContent: 'center', pb: 3 }}>
                <Button
                  variant="contained"
                  endIcon={<ArrowForwardIcon />}
                  sx={{ bgcolor: card.color }}
                >
                  Open
                </Button>
              </CardActions>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default HRMLandingPage;
